import { render } from "./homeTeacherTrain.vue?vue&type=template&id=1de6ae2b&scoped=true"
import script from "./homeTeacherTrain.vue?vue&type=script&lang=js"
export * from "./homeTeacherTrain.vue?vue&type=script&lang=js"

import "./homeTeacherTrain.vue?vue&type=style&index=0&id=1de6ae2b&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de6ae2b"]])

export default __exports__